import axios from "axios";
import { FC, useEffect, useState, CSSProperties } from "react";
import { toastfy } from "../../../toast/Toast";
import { showErrorMessage } from "../../../../helpers/MessagesHelper";
import { useNavigate } from "react-router-dom";

interface SwitchProps {
  activeColor?: string;
  inactiveColor?: string;
  onChange?: (isActive: boolean) => void;
  style?: CSSProperties;
  active: boolean;
  itemId: number;
  module: string;
  token?: string;
  apiUrl?: string;
  setDashboardUpdate: React.Dispatch<React.SetStateAction<boolean>>;
}

const SwitchStatus: FC<SwitchProps> = ({
  activeColor = "#50CD89",
  inactiveColor = "#F1416C",
  onChange,
  style,
  active,
  itemId,
  module,
  token,
  apiUrl,
  setDashboardUpdate,
}) => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState<boolean>(active);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    setIsActive(active);
  }, [active]);

  const handleChange = () => {
    if (isLoading) return;

    setIsLoading(true);

    const headers = {
      Authorization: `Bearer ${token}`,
      operation: `${module}/update/status`,
    };

    const updatedIsActive = !isActive;

    setIsActive(updatedIsActive);

    if (onChange) {
      onChange(updatedIsActive);
    }

    const body = {
      status: updatedIsActive ? "available" : "unavailable",
    };

    axios
      .patch(`${apiUrl}/${module}/${itemId}/status`, body, { headers })
      .then(() => {
        toastfy("success", "Operação bem sucedida! O status foi alterado.");
        setDashboardUpdate(true);
      })
      .catch((error) => {
        showErrorMessage(
          error?.response?.data?.error?.statusCode,
          error?.response?.data?.error?.message
        );

        setIsActive(!updatedIsActive);

        if (error?.response?.data?.error?.statusCode === 403) {
          navigate("/");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const switchStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    width: "50px",
    height: "28px",
    borderRadius: "25px",
    backgroundColor: isActive ? activeColor : inactiveColor,
    cursor: isLoading ? "not-allowed" : "pointer",
    opacity: isLoading ? 0.6 : 1,
    transition: "opacity 0.2s ease",
    ...style,
  };

  const handleStyle: CSSProperties = {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.8)",
    transform: `translateX(${isActive ? "25px" : "5px"})`,
    transition: "transform 0.2s ease-in-out",
  };

  return (
    <div
      style={switchStyle}
      className="mt-2"
      onClick={!isLoading ? handleChange : undefined}
    >
      <div style={handleStyle} />
    </div>
  );
};

export default SwitchStatus;
